export enum SwipeRxAPIResources {
  PICKING_TASK = 'picking-task',
  USER = 'user',
  ASSIGN_BASKET = 'basket-assignment',
  PICKING_JOB = 'picking-job',
  ALERT_NOTIFICATION = 'alert-notification',
  DASHBOARD = 'dashboard',
  REPLENISH = 'replenish',
  REPLENISH_JOB = 'replenish-job',
  STOCK_TRANSFER = 'stock-transfer',
  PACKING_TASK = 'packing-task',
  PACKING_UPLOAD = 'packing-task-upload',
  COMPANY = 'company',
  LOGIN_HISTORY = 'login-history',
  INVENTORY_ADJUSTMENT = 'inventory-adjustment',
  STO_DOCUMENT = 'sto-document',
  STO_PICK_ITEM = 'sto-item/pick',
  STO_CHECK = 'sto-check',
  STO_CHECK_UPLOAD = 'sto-check-upload',
  STO_RECEIVE_ITEM = 'sto-item/receive',
  STO = 'sto',
  INBOUND_TASK_DOCUMENT = 'inbound/document',
  INBOUND_TASK_ITEM = 'inbound/item',
  INBOUND_INVOICE = 'inbound/invoice',
  DELIVERY_NOTE = 'delivery-notes',
}
